import { TranslationFile } from 'i18n';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code'

interface QRCodeBlockProps {
	readonly qrCodeData: string
}

function QRCodeBlock({ qrCodeData }: QRCodeBlockProps) {
	const [isFullscreen, setIsFullscreen] = useState(false);
	const qrCodeButtonRef = useRef<HTMLButtonElement>(null);
	
	const handleFullscreenChange = useCallback(() => {
		setIsFullscreen(Boolean(document.fullscreenElement));
	}, []);

	const { t } = useTranslation([TranslationFile.Translation])


	useEffect(() => {
		document.addEventListener('fullscreenchange', handleFullscreenChange);
		return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
	}, [handleFullscreenChange]);


	const toggleFullscreen = () => {
		if (isFullscreen) {
			document.exitFullscreen();
		} else {
			if (qrCodeButtonRef.current) {
				qrCodeButtonRef.current.requestFullscreen();
			}
		}
	};

	useEffect(() => {
		if (qrCodeButtonRef.current) {
			qrCodeButtonRef.current.focus();
		}	
	}, []);


	return (
		<button ref={qrCodeButtonRef} id='qrCodeContainer' className='qrCodeBtn' aria-label={t('WCAG-Label-QRCode')} role="contentinfo" onClick= {toggleFullscreen}>
			<QRCode 
				value={qrCodeData}
				size={256}
				style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
				viewBox={`0 0 256 256`}
			/>
		</button>
	)
}

export default QRCodeBlock
